var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"load_title"},[_vm._v("正在拼命加载中,请耐心等待....")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }